import { createRouter } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen';
import { queryClient } from '@/lib/query-client';
import RoutePending from '@/app/components/route-pending';

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: false,
  // Skeletons stand in for a page whose route is still resolving. The 200ms delay keeps
  // cache-served navigations from flashing one, and the 300ms floor keeps a skeleton that
  // did appear on screen long enough to read as a load rather than a glitch.
  defaultPendingComponent: RoutePending,
  defaultPendingMs: 200,
  defaultPendingMinMs: 300,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
